<template>
  <div class="fit flex flex-col gap-2 overflow-hidden">
    <div class="w-full flex">
      <div class="font-bold text-sm">Notification Frequency</div>
    </div>
    <div
      class="flex-1 w-full overflow-hidden flex flex-col justify-between pb-1 rounded-lg"
      style="border: solid 1px rgb(234, 234, 234)"
    >
      <div class="w-full flex">
        <div
          class="w-1/4 flex flex-center"
          v-for="(n, i) in ['Reminder', '1st', '2nd', '3rd']"
        >
          <span
            :class="[
              { 'text-center': i != 0 },
              `bg-${['grey', 'yellow', 'warning', 'danger'][i]}`,
            ]"
            class="w-full p-1"
            >{{ n }}</span
          >
        </div>
      </div>
      <div class="w-full flex" v-for="item in data">
        <div class="w-1/4 flex flex-center px-1" v-for="(n, i) in 4">
          <span v-if="i == 0" class="w-full">{{ item.label }}</span>
          <vs-input
            v-else
            type="number"
            v-model.number="
              store.state.notification.config[item.label.toLowerCase()][i - 1]
            "
            size="small"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { store } from '../../api/api';

const data = ref([
  { label: 'Engine', v: [0, 0, 0] },
  { label: 'Document', v: [0, 0, 0] },
  { label: 'Tire', v: [0, 0, 0] },
]);
</script>

<style lang="scss" scoped></style>
